export default [
	{
		Id: 1,
		Name: "Pay360"
	},
	{
		Id: 2,
		Name: "Stripe"
	},
	{
		Id: 10,
		Name: "HOPS"
	},
	{
		Id: 11,
		Name: "HOPS Order Voucher"
	},
	{
		Id: 12,
		Name: "Third-party"
	}
];
